<template>
  <v-os-popup
    class="adapted-popup"
    v-model="isShow"
    title="适用说明"
    :closeShow="true"
    :footerShow="false"
    @close="close"
    container="body"
  >
    <template v-if="adaptedType == 1">
      <div class="adapted-info">
        {{ skuName }}是您{{ deviceType }}({{ modelName }})的
        <span class="t-bold">原装配件</span>
      </div>
      <div class="adapted-link" tabindex="0" @click="gotoList">
        也可点击
        <span class="link-span c-blue">查看其他原装配件</span>
      </div>
    </template>
    <template v-if="adaptedType == 2">
      <div class="adapted-info">
        {{ skuName }}可
        <span class="t-bold">适用</span>
        于您的{{ deviceType }}({{ modelName }})
      </div>
      <div v-if="hasOriginalCmmdy" class="adapted-link" tabindex="0" @click="gotoList">
        也可选择
        <span class="link-span c-blue">购买原装配件</span>
      </div>
    </template>
  </v-os-popup>
</template>
<script>
import env from '@/utils/clientEnv'
export default {
  name: 'AdaptedPopup',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    skuInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    adaptedInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  watch: {
    isShow(val) {
      if (val) {
        this.$track({
          cfrom: '081|072|02|077',
          event_id: '081|072|02|077',
          model: this.modelName,
          sku_id: this.skuInfo?.commoditySkuBaseInfo?.skuId,
          result: this.adaptedType,
          isno_content: this.hasOriginalCmmdy ? 1 : 2
        })
      }
    }
  },
  computed: {
    deviceType() {
      return env.isVivoPad ? '设备' : '手机'
    },
    skuName() {
      return this.skuInfo?.commoditySkuBaseInfo?.skuName
    },
    adaptedType() {
      return this.adaptedInfo?.partAdaptedToModelType
    },
    hasOriginalCmmdy() {
      return this.adaptedInfo?.hasOriginalCmmdy
    },
    modelName() {
      return this.adaptedInfo?.modelName
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    gotoList() {
      this.$track({
        cfrom: '081|072|01|077',
        event_id: '081|072|01|077',
        model: this.modelName,
        sku_id: this.skuInfo?.commoditySkuBaseInfo?.skuId,
        result: this.adaptedType
      })
      this.$emit('clickList')
    }
  }
}
</script>
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
<style lang="scss" scoped>
.adapted-popup ::v-deep .v-os-popup__content {
  font-size: 42px;
  line-height: 66px;
  // color: #000;
  box-sizing: border-box;
  min-height: auto;
  @include fontColor(#000, rgba(255, 255, 255, 0.9));
}
.adapted-info {
  position: relative;
  box-sizing: border-box;
  margin-bottom: 32px;
  word-break: break-word;
  &::before {
    content: '';
    display: inline-block;
    width: 48px;
    height: 48px;
    line-height: 66px;
    margin-right: 15px;
    vertical-align: text-bottom;
    transform-origin: left center;
    background: url('~assets/img/product/part-adapted-icons/icon-enable.png') center no-repeat;
    background-size: contain;
  }
  .t-bold {
    @include os-font-weight(36, 50);
  }
}
.adapted-link {
  cursor: pointer;
}

.vivo-fontscale-5 {
  .adapted-info {
    &::before {
      padding-bottom: 11px;
    }
  }
}
.vivo-fontscale-1 {
  .adapted-info {
    &::before {
      margin-bottom: -5px;
    }
  }
}
</style>
